<template>
    <div class="container">
    	<p>「Emoji吧」是一款超级有趣的分享交流APP，让人们从枯燥无味的文字中解脱，到达到趣味无比的Emoji乐园。</p>
        <div class="praise">
            <img src="../../assets/logo.png" class="praise-qrcode" @click="onTap">
            <p class="praise-tips">请我喝杯咖啡~</p>
        </div>
    </div>
</template>

<script>
    import { ImagePreview } from 'vant';
    import logo from '../../assets/logo.png';

    export default {
        name: "emoji app about",
        data() {
            return {}
        },
        mounted() {
        },
        methods: {
            onTap() {
                ImagePreview([logo]);
            }
        }
    }
</script>

<style lang="less" scoped>
.container {
    padding: 16px;

    .praise {
        text-align: center;

        .praise-qrcode {
            width: 200px;
            height: 200px;
            margin-top: 16px;
        }
    }
}
</style>
